export default __webpack_public_path__ + "static/mehrstufig-hybrid-international-10e32cacd1e910dda882616f9a91839d.jpg";